module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-00.45ae341e.png";